var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1990_4712",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1990_4712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 19.9997C20.916 19.9997 21.7007 19.6733 22.3535 19.0205C23.0063 18.3677 23.3327 17.583 23.3327 16.6663C23.3327 15.7497 23.0063 14.965 22.3535 14.3122C21.7007 13.6594 20.916 13.333 19.9993 13.333C19.0827 13.333 18.298 13.6594 17.6452 14.3122C16.9924 14.965 16.666 15.7497 16.666 16.6663C16.666 17.583 16.9924 18.3677 17.6452 19.0205C18.298 19.6733 19.0827 19.9997 19.9993 19.9997ZM19.9993 36.6663C15.5271 32.8608 12.1868 29.3261 9.97852 26.0622C7.77018 22.7983 6.66602 19.7775 6.66602 16.9997C6.66602 12.833 8.00629 9.51356 10.6868 7.04134C13.3674 4.56912 16.4716 3.33301 19.9993 3.33301C23.5271 3.33301 26.6313 4.56912 29.3118 7.04134C31.9924 9.51356 33.3327 12.833 33.3327 16.9997C33.3327 19.7775 32.2285 22.7983 30.0202 26.0622C27.8118 29.3261 24.4716 32.8608 19.9993 36.6663Z",
    fill: "#FFE743"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.50095138d3e5d46e55342bad7ea80d3a.svg";
export { ForwardRef as ReactComponent };